// Recovered compiled webpack factory 59059. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  function n(e) {
    return function () {
      let { cookie: t } = e;
      if (!t) return {};
      let { parse: n } = r(4300);
      return n(Array.isArray(t) ? t.join("; ") : t);
    };
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "getCookieParser", {
      enumerable: !0,
      get: function () {
        return n;
      },
    }));
}
